module.exports = __webpack_public_path__ + "img/img19.bb82f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img19.jpg
// module id = 284
// module chunks = 0